import firebase from 'firebase/app';

export default class ScaffoldStorage {
  static upload(scaffold, files) {
    if (!scaffold || !scaffold.id || !scaffold.version) {
      throw new Error(
        'Error uploading: Invalid id/version for scaffold.',
      );
    }

    const promises = [];

    files.forEach((file) => {
      promises.push(this.uploadOne(scaffold, file));
    });

    return Promise.all(promises);
  }

  static referenceFor(scaffold, file = null) {
    let reference = `scaffolds/${scaffold.id}/${
      scaffold.version
    }`;

    if (!file) {
      return firebase.storage().ref(reference);
    }

    reference += `/${file.path}`;
    return firebase.storage().ref(reference);
  }

  static uploadOne(scaffold, file) {
    return new Promise((resolve, reject) => {
      const uploadTask = this.referenceFor(
        scaffold,
        file,
      ).put(file.blob);

      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        () => {},
        (error) => {
          reject(error);
        },
        () => {
          resolve();
        },
      );
    });
  }
}
